<template>
  <div
    class="card card--annonce"
    :class="{
      'card--private': isPrivate,
      'card--highlighted': isHighlighted,
    }"
  >
    <a :href="!isSold ? url : '#'" @click="cardAdClicked">
      <div class="card__image-container">
        <div class="card__image-block">
          <div
            class="card__image-inner-container"
            :class="{ 'play-icon': hasVideo }"
          >
            <img
              loading="lazy"
              class="card__image"
              :class="{ 'fallback-image': !imageUrlMutable }"
              :alt="imgAlt"
              :title="imgAlt"
              :src="imageUrlMutable"
              @error="
                () => {
                  imageUrlMutable = null
                  imgAlt = null
                }
              "
            />
          </div>
          <!-- LABEL CONTAINER START -->
          <div
            class="card__label--container card__label--container-company"
            v-if="dealerLogo"
          >
            <div class="card__label card__label--company">
              <div class="card__label--absolute">
                <div
                  class="card__label--image"
                  :style="{
                    'background-image': 'url(' + dealerLogo + ')',
                  }"
                ></div>
              </div>
            </div>
          </div>
          <div class="card__label--container">
            <div
              v-for="(label, index) in labels"
              :key="'label' + index"
              :class="'card__label--' + label.css"
              class="card__label"
            >
              <div class="card__text--label">
                <div>{{ label.text }}</div>
              </div>
            </div>
          </div>
          <!-- LABEL CONTAINER END -->
        </div>
      </div>

      <div class="card__content">
        <div>
          <div class="card__text-container">
            <div
              class="card__text card__text--make-model"
              v-html="makeModel"
            ></div>
            <div class="card__text card__text--sm" v-html="variant"></div>
          </div>
          <div class="card-details">
            <!-- KILOMETERS -->
            <div class="card-details__container" v-if="kilometers">
              <div class="card-details__icon">
                <div
                  class="card-details__icon card-details__icon--kilometers"
                ></div>
              </div>
              <div class="card-details__text card__text--xs flex gap-x-5">
                <div v-html="kilometers"></div>
                <div>km</div>
              </div>
            </div>

            <!-- YEAR -->
            <div class="card-details__container" v-if="year">
              <div class="card-details__icon">
                <div class="card-details__icon card-details__icon--year"></div>
              </div>
              <div
                class="card-details__text card__text--xs"
                v-html="year"
              ></div>
            </div>

            <!-- LOCATION -->
            <div class="card-details__container" v-if="location">
              <div class="card-details__icon">
                <div
                  class="card-details__icon card-details__icon--location"
                ></div>
              </div>
              <div
                class="card-details__text card__text--xs"
                v-html="location"
              ></div>
            </div>

            <!-- PROPELLANTTYPE -->
            <div
              class="card-details__container card-details__container--show-list"
              v-if="propellantType"
            >
              <div class="card-details__icon">
                <div
                  class="card-details__icon card-details__icon--propellant-type"
                ></div>
              </div>
              <div
                class="card-details__text card__text--xs"
                v-html="propellantType"
              ></div>
            </div>

            <!-- KMPERLITER -->
            <div
              class="card-details__container card-details__container--show-list"
              v-if="kmPerLiter"
            >
              <div class="card-details__icon">
                <div
                  class="card-details__icon card-details__icon--km-per-liter"
                ></div>
              </div>
              <div
                class="card-details__text card__text--xs"
                v-html="kmPerLiter"
              ></div>
            </div>
          </div>
        </div>
        <div class="card__text-container card__price-container">
          <p v-if="oldPriceText" class="card__text--old-price">
            {{ oldPriceText }}
          </p>
          <p class="card__price">
            {{ priceText }}
            <span
              v-if="isLeasingPrice"
              class="card__text--xs card__leasing-price"
            >
              leasing pr. md.
            </span>
          </p>
        </div>
      </div>
    </a>
    <!-- sold CONTAINER START -->
    <div class="card__sold" v-if="isSold">
      <p class="card__sold-text">Annoncencen er desværre ikke aktiv længere</p>
      <!-- SØG LIGNENDE BIL ER IKKE MED I FASE 1 - VIST NOK? -->
      <!--
      <a class="card__sold-button button button--invert" href="#"
        >Søg lignende bil</a
      >
      -->
    </div>
    <!-- FAVORITE CONTAINER START -->
    <div class="card__favorite--container" @click="toggleFavorite()">
      <div
        class="card-details__icon card-details__icon--circle card-details__icon-see-through"
      >
        <div class="card-details__icon card-details__icon--empty"></div>
      </div>
      <div
        class="card-details__icon card-details__icon-absolute"
        :class="[
          isFavorized
            ? 'card-details__icon--star-filled'
            : 'card-details__icon--star',
        ]"
      ></div>
    </div>
    <!-- FAVORITE CONTAINER END -->
  </div>
</template>

<script>
import { app } from '@/main'

import { handleToggle } from '@components/Ad/AdFavoriteHandlerFunction'
import { decodeHTMLEntities } from '@/functions'

export default {
  props: {
    eventBus: { default: null, type: Object },

    id: { default: null, type: Number },
    url: { default: '', type: String },
    imageUrl: { default: '', type: String },
    makeModel: { default: '', type: String },
    variant: { default: '', type: String },

    kilometers: { default: null, type: String },
    location: { default: null, type: String },
    year: { default: null, type: String },
    propellantType: { default: null, type: String },
    kmPerLiter: { default: null, type: String },

    labels: { default: null, type: Array },

    isHighlighted: { default: false, type: Boolean },
    dealerLogo: { default: '', type: String },
    isFavorite: { default: false, type: Boolean },
    isPrivate: { default: false, type: Boolean },
    isSold: { default: false, type: Boolean },
    hasVideo: { default: false, type: Boolean },

    isLeasingPrice: { default: false, type: Boolean },
    priceText: { default: '', type: String },
    oldPriceText: { default: '', type: String },
  },
  data() {
    return {
      imgAlt: `${decodeHTMLEntities(this.makeModel)} ${decodeHTMLEntities(
        this.variant
      )}`,
      isFavorized: this.isFavorite,
      imageUrlMutable: this.imageUrl,
    }
  },
  methods: {
    toggleFavorite() {
      const toBeFavorized = !this.isFavorized

      handleToggle(this.id, toBeFavorized)
    },
    handleFavoriteAddedCallback(adId) {
      if (adId !== this.id) return
      this.isFavorized = true
    },
    handleFavoriteRemovedCallback(adId) {
      if (adId !== this.id) return
      this.isFavorized = false
    },
    cardAdClicked() {
      if (this.eventBus === null) return
      this.eventBus.emit('card-ad-clicked')
    },
  },
  created() {
    app.mitt.on('favorite-added', this.handleFavoriteAddedCallback)

    app.mitt.on('favorite-removed', this.handleFavoriteRemovedCallback)
  },
  watch: {
    isFavorite(newValue) {
      this.isFavorized = newValue
    },
  },
}
</script>

<style lang="scss">
@import 'CardAd.scss';
</style>
